function getSecondsToMilliseconds(seconds) {
  if (!seconds) return 0;
  const milliseconds = seconds * 1000;
  return milliseconds || 0;
}

export default getSecondsToMilliseconds;
